import { AgeGroup } from 'constants/components'
import { getAgeGroupFromAge } from 'stores/helpers/AgeGroups'

export const TIMEOUT_TWO_MINUTES = 120000 // 2 minutes
export const TIMEOUT_THREE_MINUTES = 180000 // 3 minutes
export const TIMEOUT_FIVE_MINUTES = 300000 // 5 minutes
/**
 * Determines the timeout.
 *
 * @param {number} debtorsAge
 * @returns {number} The timeout duration in milliseconds or five minutes if no timeout is applicable.
 */
export const determineTimeout = (
  debtorsAge: number,
  isOldAgeShorterTimeout: boolean
): number => {
  const ageGroup = getAgeGroupFromAge(debtorsAge)

  if (ageGroup === AgeGroup.YOUNG_AGE_GROUP) {
    return TIMEOUT_THREE_MINUTES
  }
  if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
    return TIMEOUT_TWO_MINUTES
  }
  if (ageGroup === AgeGroup.OLD_AGE_GROUP && isOldAgeShorterTimeout) {
    return TIMEOUT_TWO_MINUTES
  }
  return TIMEOUT_FIVE_MINUTES
}
